import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
interface KeyboardShortcut {
  key: string
  ctrlKey?: boolean
  shiftKey?: boolean
  altKey?: boolean
  action: () => void
}
export function useKeyboardShortcuts(
  shortcuts: KeyboardShortcut[] = [],
  enabled = true,
) {
  useEffect(() => {
    if (!enabled || !shortcuts || shortcuts.length === 0) return
    const handleKeyDown = (event: KeyboardEvent) => {
      // Ignore shortcuts when user is typing in an input or textarea
      const target = event.target as HTMLElement
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable
      ) {
        return
      }
      const matchingShortcut = shortcuts.find((shortcut) => {
        const keyMatches =
          event.key.toLowerCase() === shortcut.key.toLowerCase()
        const ctrlMatches = !!shortcut.ctrlKey === event.ctrlKey
        const shiftMatches = !!shortcut.shiftKey === event.shiftKey
        const altMatches = !!shortcut.altKey === event.altKey
        return keyMatches && ctrlMatches && shiftMatches && altMatches
      })
      if (matchingShortcut) {
        event.preventDefault()
        matchingShortcut.action()
      }
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [shortcuts, enabled])
}
export function useGlobalKeyboardShortcuts() {
  const navigate = useNavigate()
  const shortcuts: KeyboardShortcut[] = [
    {
      key: 'd',
      action: () => navigate('/dashboard'),
    },
    {
      key: 'r',
      action: () => navigate('/results'),
    },
    {
      key: 'i',
      action: () => navigate('/integrations'),
    },
    {
      key: 't',
      action: () => navigate('/taxonomy'),
    },
    {
      key: 'p',
      action: () => navigate('/runner-preview'),
    },
  ]
  return shortcuts
}
